import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import COLORS from 'lib/colors';


function MenuButton({ clickHandler, rowNode, label }) {
  return (
    <IconButton className='actionButton' onClick={(event)=>{ event.stopPropagation(); clickHandler(event, rowNode) }} aria-label={label} size="small" sx={{color: COLORS.charcoal, padding: .5 }}>
      <MoreHorizIcon />
    </IconButton>
  )
}

// TODO: factor out the menu components for reuse (VEGA-736)
export function GroupRowMenu({ rowNode, dispatch, setMenuRowId, disableDelete }) {
  const [controlAnchorEl, setControlAnchorEl] = useState(null)

  function handleControlOpen(event) {
    if (controlAnchorEl !== event.currentTarget) {
      setControlAnchorEl(event.currentTarget)
      setMenuRowId(rowNode.id)
    }
  }

  function handleControlClose() {
    setControlAnchorEl(null)
    setMenuRowId(null)
  }

  return  (
    <>
      <MenuButton
        clickHandler={(event) => handleControlOpen(event)}
        rowNode={rowNode}
        label={`Group ${rowNode.id} Menu`}
      />

      <Menu
        anchorEl={controlAnchorEl}
        open={Boolean(controlAnchorEl)}
        onClose={handleControlClose}
        anchorOrigin={{vertical: 24, horizontal: 30}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
        PaperProps={{
          sx: { width: 240, textOverflow: 'ellipsis', overflowX: 'hidden', overflowY: 'auto', whiteSpace: 'nowrap' },
        }}
      >
        <MenuItem onClick={() => {dispatch({ type: 'OPEN_EDIT', groupId: rowNode.id }); handleControlClose()}}>
          Edit Group
        </MenuItem>
        <MenuItem onClick={() => {dispatch({ type: 'OPEN_DUPLICATE', groupId: rowNode.id }); handleControlClose()}} >
          Duplicate Group
        </MenuItem>
        <Tooltip title={disableDelete ? 'Groups in use cannot be deleted.' : undefined}>
          <span>
            <MenuItem onClick={() => {dispatch({ type: 'OPEN_DELETE', groupId: rowNode.id }); handleControlClose()}} disabled={disableDelete}>
              Delete Group
            </MenuItem>
          </span>
        </Tooltip>
      </Menu>
    </>
  )
}
